/* eslint-disable @typescript-eslint/no-explicit-any */
import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export async function getEmployee(
    id: string
): Promise<any> {
  try {
    const response = await axiosInstance.get(`${config.apiUrl}/auth/employee/${id}`);
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data.message || "Error fetching Employee"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
